export const ListSoldOutOverlay = () => (
  <div className="absolute inset-0 mx-auto flex h-[5rem] items-center justify-center">
    <span className="absolute z-10 text-[2.2rem] font-semibold tracking-wider text-white">
      SOLD
    </span>
    <div className="absolute h-full w-full bg-brand-secondary opacity-80" />
  </div>
);
